<script>
// Cloud renderer. (Ichimoku)

import { Overlay } from '../../'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Ichi',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'C451', version: '1.0.0',
                desc: 'Ichimoku Cloud based on scripts',
                preset: {
                    name: 'Ichi',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color1: 'lightgreen',
                        color2: 'orange',
                        back1: '#79ff9e22',
                        back2: '#ef535022',
                        drawLines: true
                    }
                }
            }
        },
        draw(ctx) {
            const settings=this.sett,data=this.data,layout=this.layout;
            if(settings.showCloud!==false){
                ctx.save();ctx.globalAlpha=(settings.opacity??100)/100;
                for(let i=1;i<data.length;i++){
                    const before=data[i-1],after=data[i];
                    if(![before[1],before[2],after[1],after[2]].every(Number.isFinite))continue;
                    ctx.fillStyle=before[1]>before[2]?this.back1:this.back2;
                    ctx.beginPath();ctx.moveTo(layout.t2screen(before[0]),layout.$2screen(before[1]));
                    ctx.lineTo(layout.t2screen(after[0]),layout.$2screen(after[1]));
                    ctx.lineTo(layout.t2screen(after[0]),layout.$2screen(after[2]));
                    ctx.lineTo(layout.t2screen(before[0]),layout.$2screen(before[2]));ctx.fill();
                }
                ctx.restore();
            }
            if(settings.drawLines!==false){
                if(settings.showLeadingA!==false)drawIndicatorPlot(ctx,data,layout,settings,0,{color:this.color1,width:this.line_width});
                if(settings.showLeadingB!==false)drawIndicatorPlot(ctx,data,layout,settings,1,{color:this.color2,width:this.line_width});
            }
        },
        mapp(p) {
            const layout = this.$props.layout
            return p && {
                x:  layout.t2screen(p[0]),
                y1: layout.$2screen(p[1]),
                y2: layout.$2screen(p[2])
            }
        },
        use_for() { return ['Ichi'] },
        data_colors() { return [this.color1, this.color2] },
        calc() {
            return {
                props: {
                    CP: { def: 9, text: 'Conversion Line Length' },
                  	BP: { def: 26, text: 'Base Line Length' },
                  	LSP: { def: 52, text: 'Lagging Span 2 Length' },
                  	DIZ: { def: 26, text: 'Displacement' },
                    baseColor: { def: 'brown', text: 'Base Line Color'},
                    conversionColor: {
                        def: 'lightblue',
                        text: 'Conversion Line Color'
                    },
                    laggingColor: {
                        def: '#66CC66',
                        text: 'Lagging Span Color'
                    }
                },
                update: `
                    let donchian = (len, id) => ts(
                        avg(lowest(low, len)[0], highest(high, len)[0]), id
                    )
                    let conversionLine = donchian(CP, 1)
                    let baseLine = donchian(BP, 2)
                    let leadLine1 = ts(avg(conversionLine[0], baseLine[0]))
                    let leadLine2 = donchian(LSP, 3)
                    let lagging = ts(close[0])


                    offset(this, DIZ - 1)
                    offset(lagging, -DIZ + 1)
                    onchart([conversionLine, baseLine], 'Base Lines', {
                        colors: [conversionColor, baseColor]
                    })
                    onchart(lagging, 'Lagging Span', {
                        color: laggingColor
                    })
                    return [leadLine1[0], leadLine2[0]]
                `
            }
        }
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings
        },
        line_width() {
            return this.sett.lineWidth || 0.75
        },
        color1() {
            return this.sett.color1 || 'lightgreen'
        },
        color2() {
            return this.sett.color2 || 'orange'
        },
        back1() {
            return this.sett.back1 || '#79ff9e22'
        },
        back2() {
            return this.sett.back2 || '#ef535022'
        },
        draw_lines() {
            return this.sett.drawLines
        }
    },
    data() {
        return {
            COLORS:
            [
                '#42b28a', '#5691ce', '#612ff9',
                '#d50b90', '#ff2316'
            ]
        }
    }

}
</script>
